import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT



//获取列表数据
export const getListData = (params) => {
  return axios.post(root+'/workflow/waitaudit/list', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.get(root+'/workflow/waitaudit/detail', {params:params})
}

//保存某一行的数据
export const pass = (params) => {
  return axios.post(root + '/workflow/waitaudit/pass', qs.stringify(params))
}

export const  removeData= (params) => {
  return axios.post(root+'/workflow/waitaudit/remove', qs.stringify(params))
}

export const registerApi = (params) => {
  return axios.post(root + '/set/externaldept/registerApi', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/workflow/waitaudit.js